<template>
  <div class="order-basket">
    <b-alert v-if="missingItems && missingItems.length > 0" variant="warning" show class="missing-basketitems">
      <strong class="d-block mb-2">Nachfolgende Positionen konnten nicht verarbeitet werden:</strong>
      <span v-for="(item, index) in missingItems" :key="index" class="d-inline-block mr-3 mb-1">
        <span>{{ item.Quantity || item.quantity }} x </span><b-badge variant="secondary" class="mr-1">{{ item.identifier }}</b-badge>
        <span class="text-muted">- {{ resolveNotOrderableReason(item.reason) }}</span>
      </span>
    </b-alert>
    <h2>{{ $t('components.order.basket.title') }}</h2>
    <b-row>
      <b-col :cols="12" tag="article">
        <div class="basket-items">
          <div class="items-header">
            <div class="area-description">{{ $t('components.order.basket.header.description') }}</div>
            <div class="area-quantity">{{ $t('components.order.basket.header.quantity') }}</div>
            <div class="area-warehouse">{{ $t('components.order.basket.header.warehouse') }}</div>
            <div class="area-actions-header"></div>
          </div>

          <div class="items-main">
            <basket-item v-for="item in orderItems" :key="item.basketItemId || item.orderItemId" :item="item" :order="order" />
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BasketItem from '@/components/order/BasketItem';
import { resolveNotOrderableReason } from '@/assets/js/helper/not-orderable-reason'

export default {
  name: 'OrderBasket',
  components: {
    BasketItem
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    orderItems() {
      // Prioritize orderedBasket.items as it contains all original basket items including deleted ones
      // fullOrderModel.items only contains active items (deleted items are excluded)
      // Support both old (executedBasket) and new (orderedBasket/items) structures
      if (this.order.orderedBasket && this.order.orderedBasket.items && Array.isArray(this.order.orderedBasket.items)) {
        return this.order.orderedBasket.items
      } else if (this.order.items && Array.isArray(this.order.items)) {
        return this.order.items
      }
      return []
    },
    missingItems() {
      if (this.order.orderedBasket && this.order.orderedBasket.configuration && this.order.orderedBasket.configuration.unknownOrderItems && Array.isArray(this.order.orderedBasket.configuration.unknownOrderItems)) {
        return this.order.orderedBasket.configuration.unknownOrderItems
      } else if (this.order.configuration && this.order.configuration.unknownOrderItems && Array.isArray(this.order.configuration.unknownOrderItems)) {
        return this.order.configuration.unknownOrderItems
      }
      return []
    }
  },
  methods: {
    resolveNotOrderableReason
  }
}
</script>

<style lang="scss">
// mobile

$orderbasket-emptymessage-content-text-align: inherit !default;

$orderbasket-items-grid-column-gap: $grid-gutter-width * 0.5 !default;
$orderbasket-items-grid-row-gap: $spacer * 0.4 !default;
$orderbasket-items-grid-columns: [start] auto 4fr auto auto auto auto [end] !default;
$orderbasket-items-grid-rows: min-content auto min-content !default;
$orderbasket-items-grid-area-gap-y: $spacer !default;

$orderbasket-items-header-font-size: $font-size-sm !default;
$orderbasket-items-header-color: $dark !default;
$orderbasket-items-header-line-height: 1.1 !default;

$orderbasket-items-footer-actions-gap-y: $spacer * 0.5 !default;
$orderbasket-items-footer-actions-gap-x: $spacer * 2 !default;

.order-basket {
  .basket-emptymessage {
    margin-top: 0 !important;

    .emptymessage-image {}

    .emptymessage-content {
      text-align: $orderbasket-emptymessage-content-text-align;
    }
  }

  .basket-items {
    display: grid;
    column-gap: $orderbasket-items-grid-column-gap;
    row-gap: $orderbasket-items-grid-row-gap;
    grid-template-columns: $orderbasket-items-grid-columns;
    grid-template-rows: $orderbasket-items-grid-rows;

    [class*="area-"] {
      grid-row: auto;
    }

    .items-header {
      display: contents;
      font-size: $orderbasket-items-header-font-size;
      color: $orderbasket-items-header-color;
      line-height: $orderbasket-items-header-line-height;

      .area-description {
        grid-column: start / 3;
      }
    }

    .area-image,
    .area-description,
    .area-configuration,
    .area-quantity {
      margin-bottom: 0;
    }

    .area-separator {
      grid-row-gap: 0;
      grid-column: start / end;
      justify-self: stretch;
    }

    .area-image {
      grid-column: start;
      grid-row: auto / span 2;
      justify-self: stretch;
    }

    .area-description {
      grid-column: 2;
    }

    .area-configuration {
      grid-column: 2 / span 3;
      align-self: center;
    }

    .area-quantity {
      grid-column: 3;
      justify-self: right;
    }

    .area-warehouse {
      grid-column: 4;
      justify-self: flex-end;
    }

    .area-totalprice {
      grid-column: 5;
      justify-self: flex-end;
    }

    .area-actions {
      grid-column: 6;
      justify-self: flex-end;
    }

    .area-actions-header {
      grid-column: 6;
      justify-self: flex-end;
    }

    .area-services {
      grid-column: start / end;
      justify-self: flex-end;
    }

    .items-main {
      display: contents;
    }

    .items-footer {
      display: contents;

      .area-basketactions-start {
        grid-column: start / 4;
      }

      .area-basketactions-end {
        grid-column: 4 / end;
        justify-self: flex-end;
        margin-top: 0;
      }

      .footer-actions {
        display: flex;
        margin: ($orderbasket-items-footer-actions-gap-y * -0.5) ($orderbasket-items-footer-actions-gap-x * -0.5);

        a {
          display: block;
          padding: ($orderbasket-items-footer-actions-gap-y * 0.5) ($orderbasket-items-footer-actions-gap-x * 0.5);
        }
      }
    }
  }
}
</style>
